export default __webpack_public_path__ + "static/media/logo.27495e68.svg";